"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = void 0;

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var getTextChildren_1 = __importDefault(require("../assets/getTextChildren"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Progress_1 = __importDefault(require("../Progress/Progress"));

var Button_styles_1 = require("./Button.styles");

exports.ButtonIcon = function (_a) {
  var _b;

  var classes = _a.classes,
      icon = _a.icon,
      textChildren = _a.textChildren,
      after = _a.after;
  return react_1.default.createElement("div", {
    className: classnames_1.default(classes.inner, classes.innerIcon, (_b = {}, _b[classes.iconWithText] = Boolean(icon && textChildren && !after), _b[classes.iconWithTextBefore] = Boolean(icon && textChildren && after), _b))
  }, react_1.default.createElement(Icon_1.default, {
    icon: icon
  }));
};

var Button = function Button(props) {
  var _a, _b;

  var type = props.type,
      responsive = props.responsive,
      progress = props.progress,
      progressText = props.progressText,
      primary = props.primary,
      warning = props.warning,
      danger = props.danger,
      secondary = props.secondary,
      icon = props.icon,
      iconAfter = props.iconAfter,
      classes = props.classes,
      disabled = props.disabled,
      fluid = props.fluid,
      large = props.large,
      small = props.small,
      flat = props.flat,
      round = props.round,
      contrast = props.contrast,
      variant = props.variant,
      iconColorInherit = props.iconColorInherit,
      dangerouslyApplyFocusStyle = props.dangerouslyApplyFocusStyle,
      dangerouslyApplyHoverStyle = props.dangerouslyApplyHoverStyle,
      dangerouslyApplyActiveStyle = props.dangerouslyApplyActiveStyle,
      dangerouslyStopAnimation = props.dangerouslyStopAnimation;
  var textChildren = getTextChildren_1.default(props);
  var isOnlyIcon = Boolean(icon && !textChildren) || iconAfter && !textChildren;
  var flatVariant = variant === 'flat';
  var bgColorInheritFromIcon = iconColorInherit || isOnlyIcon;
  var className = classnames_1.default(classes.base, (_a = {}, _a[classes.primary] = primary, _a[classes.warning] = warning, _a[classes.danger] = danger, _a[classes.secondary] = secondary, _a[classes.fluid] = fluid, _a[classes.large] = large, _a[classes.small] = small, _a[classes.flat] = flat, _a[classes.variantFlat] = flatVariant, _a[classes.bgColorInheritFromIcon] = bgColorInheritFromIcon, _a[classes.round] = isOnlyIcon && round, _a[classes.contrast] = contrast, _a[classes.disabled] = disabled, _a[classes.progressWrapper] = progress, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a[classes.icon] = isOnlyIcon, _a[classes.focus] = dangerouslyApplyFocusStyle, _a[classes.hover] = dangerouslyApplyHoverStyle, _a[classes.active] = dangerouslyApplyActiveStyle, _a));
  return react_1.default.createElement("button", __assign({}, baseProps_1.default(props), {
    className: className,
    disabled: disabled || progress,
    type: type
  }), icon && react_1.default.createElement(exports.ButtonIcon, {
    classes: classes,
    icon: icon,
    textChildren: textChildren
  }), (progress || progressText) && react_1.default.createElement("div", {
    className: classnames_1.default(classes.inner, (_b = {}, _b[classes.progress] = progress, _b[classes.progressText] = progressText, _b))
  }, react_1.default.createElement(Progress_1.default, {
    accent: primary && !flatVariant,
    primary: primary && flatVariant,
    size: progress ? 20 : 16,
    dangerouslyStopAnimation: dangerouslyStopAnimation
  })), react_1.default.createElement("span", {
    className: classnames_1.default(classes.innerText, classes.inner),
    style: {
      visibility: progress ? 'hidden' : 'visible'
    }
  }, textChildren), iconAfter && react_1.default.createElement(exports.ButtonIcon, {
    icon: iconAfter,
    after: true,
    classes: classes,
    textChildren: textChildren
  }));
};

Button.defaultProps = {
  variant: 'regular',
  type: 'button',
  responsive: 'auto'
};
exports.default = withResponsive_1.withResponsive(withStyles_1.withStyles(Button_styles_1.styles)(Button));